import React from 'react';
import styled from 'styled-components';

import { FraudAlert } from '@/assets/icons';
import { otherColors } from '@/styles/colors';

interface IProps {
  message?: string;
  className?: string;
  children?: React.ReactNode;
  headerElement?: React.ReactNode;
}

const ErrorCard = ({ message, className, children, headerElement }: IProps): React.ReactElement => {
  return (
    <Container className={className}>
      <Head>
        <Icon className="error-icon" />
        {message && <Message>{message}</Message>}
        {headerElement}
      </Head>
      {children}
    </Container>
  );
};

const Container = styled.div`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${otherColors.lxc.red};
  padding-bottom: 0px;
  padding-top: 16px;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const Icon = styled.div`
  width: 26px;
  height: 26px;
  margin-right: 17px;
  background-image: url(${FraudAlert});
  background-repeat: no-repeat;
`;

const Message = styled.div`
  font-size: 18px;
  color: ${otherColors.punch_red};
  width: calc(100% - 26px);
`;

export { ErrorCard };
